export type BrowserKey = "chromeAndroid" | "samsung" | "safariIos" | "chromeDesktop" | "edge" | "firefox" | "safariMac";

export const BROWSER_KEYS: BrowserKey[] = ["chromeAndroid", "samsung", "safariIos", "chromeDesktop", "edge", "firefox", "safariMac"];

/** The guide most likely to match the browser the user is holding; they can pick another. */
export function guessBrowser(userAgent: string, touchMac = false): BrowserKey {
  if (/iPhone|iPad|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && touchMac)) return "safariIos";
  if (/Android/.test(userAgent)) return /SamsungBrowser/.test(userAgent) ? "samsung" : "chromeAndroid";
  if (/Firefox\//.test(userAgent)) return "firefox";
  if (/Edg\//.test(userAgent)) return "edge";
  if (/Macintosh/.test(userAgent) && /Safari\//.test(userAgent) && !/Chrome\//.test(userAgent)) return "safariMac";
  return "chromeDesktop";
}
